import { MapLayerGroupControl } from '@/views/map/MapLayerManager/MapLayerGroupControl/MapLayerGroupControl';
import { useAppSelector, useAppDispatch } from '@/app/hooks';
import { update as updateMapLayerConfig } from '@/features/mapLayerSlice';
import { LayerType } from '@/views/map/layers/types';
import { useClientTerminology } from '@/views/list/NetworkTerms';

export const WorkStatusControl = () => {
  const dispatch = useAppDispatch();
  const layerConfig = useAppSelector((s) => s.mapLayer);
  const { getClientTerm } = useClientTerminology();

  const isActive = layerConfig[LayerType.work_status].visible;

  const toggleWorkStatusLayer = (v: boolean) =>
    dispatch(
      updateMapLayerConfig({
        [LayerType.work_status]: { visible: v },
      })
    );

  return (
    <MapLayerGroupControl
      title={getClientTerm('map.layerManager.workStatusTitle')}
      onVisibilityChange={toggleWorkStatusLayer}
      isGroupVisible={isActive}
      data-testid="work-status-control"
    />
  );
};
